/**
 * ODX Cinematheque — Phase B (mobile plinth expand) + Phase C (viewport-center chroma drain).
 * Depends on odx-magnetic-track.js (strict media / snap).
 * Phase C: CHROMA_S = 5s grayscale→color on `.odx-cine-plinth-media` (--odx-cine-g).
 * Phase B: tap `.odx-cine-plinth__media-wrap` ≤749px → `.odx-cine-mobile-expanded` (~27px apparent growth, CSS).
 */
(function () {
  'use strict';

  var CHROMA_S = 5;
  var MOBILE_MQ = '(max-width: 749px)';
  /** Intersection root: middle horizontal band (~16% viewport) = "center of screen" for chroma. */
  var CHROMA_ROOT_MARGIN = '-42% 0px -42% 0px';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  /**
   * Phase C: when each `.odx-cine-plinth-media` crosses the vertical center band, drain grayscale
   * over CHROMA_S seconds (--odx-cine-g → 0).
   */
  function initChromaDrain(root) {
    var medias = root.querySelectorAll('.odx-cine-plinth-media');
    if (!medias.length || typeof IntersectionObserver === 'undefined') return;

    var reduced = prefersReducedMotion();
    var dur = reduced ? 0.05 : CHROMA_S;

    function arm(el) {
      if (el.dataset.odxCineChromaDone === '1') return;
      el.dataset.odxCineChromaDone = '1';
      el.style.setProperty('--odx-cine-g', '0');
      el.style.transition =
        'filter ' + dur + 's cubic-bezier(0.18, 0, 0.12, 1), -webkit-filter ' + dur + 's cubic-bezier(0.18, 0, 0.12, 1)';
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0) arm(en.target);
        });
      },
      {
        root: null,
        rootMargin: CHROMA_ROOT_MARGIN,
        threshold: [0, 0.01, 0.15, 0.35],
      },
    );

    medias.forEach(function (m) {
      io.observe(m);
    });
  }

  /**
   * Phase B: on narrow viewports, tapping the media wrap toggles a scale-up while keeping the
   * amber frame (14px bleed) visible around the plinth.
   */
  function initMobileExpand(root) {
    root.addEventListener(
      'click',
      function (ev) {
        if (!isMobile()) return;
        var wrap = ev.target.closest('.odx-cine-plinth__media-wrap');
        if (!wrap || !root.contains(wrap)) return;
        var frame = wrap.closest('.odx-cine-plinth__frame');
        if (!frame || !root.contains(frame)) return;
        frame.classList.toggle('odx-cine-mobile-expanded');
      },
      false,
    );
  }

  function init(root) {
    if (!root || root.dataset.odxCinemathequeJuice === '1') return;
    root.dataset.odxCinemathequeJuice = '1';
    initChromaDrain(root);
    initMobileExpand(root);
  }

  function boot() {
    document.querySelectorAll('.odx-cinematheque-track[data-odx-magnetic]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('.odx-cinematheque-track[data-odx-magnetic]').forEach(init);
  });
})();
